import Head from "next/head";

export default function LegalDpaPage() {
  return (
    <div>
      <Head>
        <title>Data processing agreement - Graphy</title>
        <meta name="description" content="Graphy Data processing agreement" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head>
      <iframe
        src="https://drive.google.com/file/d/1rAI5Ror36hy6yy8fWCrim2l57P-rbW81/preview"
        className="h-[100vh] w-[100vw]"
      ></iframe>
    </div>
  );
}
